import { render, staticRenderFns } from "./VideoGreen.vue?vue&type=template&id=9cadd26a&"
import script from "./VideoGreen.vue?vue&type=script&lang=js&"
export * from "./VideoGreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports